/// <amd-module name="Test/TestPlansLibrary/Pivots/TestCasesPivot/TestCasePivotConstants" />
export const Id = "id";
export const Title = "title";
export const AssignedTo = "assignedTo";
export const State = "state";
export const AreaPath = "areaPath";
export const Tags = "tags";
export const TestCasesTextFilterItemKey = "testCasesFilterText";
export const TestCasesAssignedToFilterItemKey = "testCasesAssignedToFilter";
export const TestCasesStateFilterItemKey = "testCasesStateFilter";
export const TestCasesAreaFilterItemKey = "testCasesAreaFilter";
export const TestCasesTagsFilterItemKey = "testCasesTagsFilter";
export const TestCasesPriorityFilterItemKey = "testCasesPriorityFilter";
export const TestCasesQueriesFilterItemKey = "testCasesQueriesFilter";